import React from 'react'

import { Box, Circle, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'

type Props = {
  circleColor: string
  title: string
  minutes: number
  children?: React.ReactNode
}

const Section = ({ circleColor, title, minutes, children }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween" padding="s16">
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Box>
            <Circle color={circleColor} size={10} />
          </Box>
          <Text size="300" weight="medium">
            {title}
          </Text>
        </Box>
        <Box flexDirection="row" alignItems="center" gap="s8" justifyContent="flexEnd">
          <MinutesToText value={minutes} size="300" weight="medium" />
        </Box>
      </Box>

      {children && minutes > 0 && (
        <Box padding="s16" background="grey200">
          {children}
        </Box>
      )}
    </Box>
  )
}

export default Section
